import {ISsoRedirectController} from "./ISsoRedirectController";
import {AbstractController} from "../../../controllers/AbstractController";
import {inject, Injectable} from "@angular/core";
import {AuthenticationService} from "../../../services/authentication.service";
import {AppEventBus} from "../../../event-buses/app.event-bus";
import {AppEvent} from "../../../event-buses/AppEvent";
import {AppEventName} from "../../../event-buses/AppEventName";
import {LocalStorageRepository} from "../../../repositories/local-storage.repository";

@Injectable()
export class SsoRedirectController extends AbstractController implements ISsoRedirectController {

  private readonly appEventBus = inject(AppEventBus);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly localStorageRepository = inject(LocalStorageRepository);

  constructor() {
    super();
  }

  handleInit(eventData: any): void {
    const route = this.getCurrentRoute();
    this.fetchQueryParams(route, ['code']).subscribe((params) => {
      if(params['code']) {
        this.processSsoCode(params['code']);
      }
      else {
        this.errorToast(`Failed to login`);
        this.appEventBus.dispatch(new AppEvent(AppEventName.LogoutRequest, {}));
      }
    });
  }

  protected processSsoCode(code: string): void {
    if(code && code.length > 0) {
      const ssoEmail = this.localStorageRepository.getSsoEmail();
      const ssoDomain = this.localStorageRepository.getSsoDomain();

      this.authenticationService.loginWithSsoCode(code, ssoEmail, ssoDomain).subscribe({
        next: (userSession) => {
          this.appEventBus.dispatch(new AppEvent(AppEventName.LoggedIn, {}));
        },
        error: (error) => {
          this.errorToast('Failed to login');
          this.appEventBus.dispatch(new AppEvent(AppEventName.LogoutRequest, {}));
        }
      });
    }
  }
}
